import { render } from "./SaveBankAccount.vue?vue&type=template&id=3a0b63f4"
import script from "./SaveBankAccount.vue?vue&type=script&lang=js"
export * from "./SaveBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__